import axios from 'axios'
import statesData from './data/states.json'
import citiesData from './data/cities.json'

export const states: any = () => {
  // return an axios-like response to keep compatibility with existing callers
  return Promise.resolve({ data: statesData })
}

export const cities = (uf: string) => {
  const ufStr = (uf || '').toString().trim()

  // resolve numeric UF code if the caller passed number-like string
  let ufCode: number | null = null
  if (/^\d+$/.test(ufStr)) {
    ufCode = parseInt(ufStr, 10)
  } else if (ufStr.length === 2) {
    // try to resolve by state abbreviation (sigla)
    const s: any = (statesData as any[]).find(st => (st.sigla || '').toUpperCase() === ufStr.toUpperCase())
    if (s) ufCode = s.id || s.codigo || null
  } else {
    // try to resolve by full state name
    const s: any = (statesData as any[]).find(st => (st.nome || '').toLowerCase() === ufStr.toLowerCase())
    if (s) ufCode = s.id || s.codigo || null
  }

  const filtered = ufCode ? (citiesData as any[]).filter(c => c.uf === ufCode) : []
  return Promise.resolve({ data: filtered })
}

export const countries = () => axios.get('v1/catalogo/countries')
